import React from 'react';

const MetricsCards = ({ activeTab, setActiveTab }) => {
  return (
    <>
      {/* Tab Buttons */}
      <div className="flex gap-4 border-b pb-2 dark:border-gray-700">
        {['Overview', 'Orders', 'Items'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium rounded-t ${
              activeTab === tab
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>
    </>
  );
};

export default MetricsCards;
